import React, {useContext, useEffect, useRef, useState} from 'react';
import {InputText} from 'primereact/inputtext';
import {InputNumber, InputNumberValueChangeEvent} from 'primereact/inputnumber';
import {InputTextarea} from 'primereact/inputtextarea';
import {Button} from 'primereact/button';
import {Dropdown, DropdownChangeEvent} from 'primereact/dropdown';
import {FileUpload, FileUploadHeaderTemplateOptions} from 'primereact/fileupload';
import {Toast} from 'primereact/toast';
import {ConfirmDialog} from 'primereact/confirmdialog';
import {KeyFact, ProductFormData} from "../../../types/product";
import {useFetch} from "../../../layout/hooks/useFetch";
import callToast, {handleChangeData, handleDataUpdate, handleRemoveRow} from "../../../utils/helper";
import Label from "../../../Component/Label";
import PageHeading from "../../../Component/PageHeading";
import {baseUrl} from "../../../utils/webInfo";
import {LayoutContext} from "../../../layout/context/LayoutContext";
import {IidName} from "../../../interfaces/interfaces";
import {useNavigate} from "react-router-dom";
import {Editor} from "primereact/editor";
import "quill/dist/quill.snow.css";


interface CommonProductProps {
    id?: number
}

const CommonProduct = ({id}: CommonProductProps) => {
    // console.log("id", id);
    const toast = useRef<Toast>(null);
    const navigate = useNavigate();
    const {accessToken} = useContext(LayoutContext);
    const [keyFacts, setKeyFacts] = useState<KeyFact[]>([{id: 1, title: '', description: ''}]);
    const {data: productCategory} = useFetch('/api/product_category?page=0&size=100');
    const {data: pregnancyLevel} = useFetch('/api/pregnancy_level?page=0&size=100');
    const {data: dosageForm} = useFetch('/api/product_dosage_form?page=0&size=100&sort=name');
    const [selectedProductCategory, setSelectedProductCategory] = useState<IidName | null>(null);
    const [selectedPregnancyLevel, setSelectedPregnancyLevel] = useState<IidName | null>(null);
    const [selectedProductDosage, setSelectedProductDosage] = useState<IidName | null>(null);
    const [btnLoading, setBtnLoading] = useState(false);
    const [composition, setComposition] = useState('');
    const [indication, setIndication] = useState('');
    const [packSize, setPackSize] = useState('');
    const [dosage, setDosage] = useState('');
    const [formDataState, setFormDataState] = useState<ProductFormData>({
        productCode: '',
        image_file: null,
        brandName: '',
        genericName: '',
        strength: '',
        mrp: null,
        tradePriceVat: null,
        offerPrice: null,
        description: '',
        discountPrice: null
    });

    const {data: productInfo} = useFetch(`/api/product/detail?filters=[["id", "${id}"]]`, [id], true, id);


    useEffect(() => {

        if (productInfo && productInfo.length > 0) {
            const product = productInfo[0];
            // Set form data
            setFormDataState({
                productCode: product.productCode,
                image_file: product.imageUrl,
                brandName: product.brandName,
                genericName: product.genericName,
                strength: product.strength,
                mrp: product.mrp,
                tradePriceVat: product.tradePriceVat,
                offerPrice: product.offerPrice,
                description: product.description,
                discountPrice: product.discountPrice
            });
            setSelectedProductCategory(product.product_category)
            setSelectedPregnancyLevel(product.pregnancy_level)
            setSelectedProductDosage(product.product_dosage_form)
            setComposition(product.composition )
            setIndication(product.indication)
            setPackSize(product.packSize)
            setDosage(product.dosage)

            const modifyKey = product.key_facts.map((key: any)=>{
                return{
                    id: key.id,
                    title: key.title,
                    description: key.description,
                }
            })

            console.log("modifyKey",modifyKey)
            setKeyFacts(modifyKey)

        }

    }, [productInfo]);

    console.log("productInfo", productInfo)

    // console.log("productCategory", productCategory);
    // console.log("formDataState", formDataState);
    // console.log("selectedProductCategory", selectedProductCategory);

    console.log("defaultValue", composition)

    const handlePlus = (): void => {
        setKeyFacts([...keyFacts, {id: Date.now(), title: '', description: ''}]);
    };

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>, id?: number) => {
        e.preventDefault();
        // Check required fields
        if (!selectedProductCategory?.id) {
            return callToast(toast, false, 'Product Category is required')
        }

        if (!selectedPregnancyLevel?.id) {
            return callToast(toast, false, 'Pregnancy Level is required')
        }

        if (!selectedProductDosage?.id) {
            return callToast(toast, false, 'Dosage Form is required')
        }

        if (!formDataState.productCode?.trim()) {
            return callToast(toast, false, 'Product Code is required')
        }

        if (!composition?.trim()) {
            return callToast(toast, false, 'Composition is required')
        }

        if (!indication?.trim()) {
            return callToast(toast, false, 'Indication is required')
        }

        if (!dosage) {
            return callToast(toast, false, 'Dosage is required')
        }

        if (!packSize) {
            return callToast(toast, false, 'Pack Size is required')
        }

        if (!formDataState.mrp) {
            return callToast(toast, false, 'MRP is required')
        }

        if (!formDataState.tradePriceVat) {
            return callToast(toast, false, 'Trade Price (with VAT) is required')
        }

        if (!formDataState.offerPrice) {
            return callToast(toast, false, 'Offer Price is required')
        }
        // Check if at least one key fact with title and description exists
        const hasValidKeyFact = keyFacts.some(
            fact => fact.title?.trim() && fact.description?.trim()
        );
        if (!hasValidKeyFact) {
            callToast(toast, false, 'At least one Key Fact with both Title and Description is required')
        }
        // Check image file (for create operation only)
        if (!id && !formDataState.image_file) {
            callToast(toast, false, 'Product Image is required')
        }


        // Create FormData object
        const formData: any = new FormData();

        // Append basic form fields
        formData.append('brandName', formDataState.brandName || '');
        formData.append('genericName', formDataState.genericName || '');
        formData.append('productCode', formDataState.productCode || '');
        formData.append('composition', composition || '');
        formData.append('indication', indication || '');
        formData.append('dosage', dosage || '');
        formData.append('packSize', packSize || '');
        formData.append('strength', String(formDataState.strength || ''));
        formData.append('description', formDataState.description || '');
        formData.append('mrp', String(formDataState.mrp || ''));
        formData.append('tradePriceVat', String(formDataState.tradePriceVat || ''));
        formData.append('offerPrice', String(formDataState.offerPrice || ''));
        formData.append('discountPrice', String(formDataState.discountPrice));
        // formData.append('image_file', String(formDataState.image_file || ''));
        selectedProductCategory?.id && formData.append('productCategoryId', selectedProductCategory?.id);
        selectedPregnancyLevel?.id && formData.append('pregnancyLevelId', selectedPregnancyLevel?.id);
        selectedProductDosage?.id && formData.append('productDosageFormId', selectedProductDosage?.id);

        // Append image file if exists

        if (formDataState.image_file) {
            formData.append('image_file', formDataState.image_file);
        }
        // Append key facts as JSON string (better for nested data)
        if (keyFacts && keyFacts.length > 0) {
            keyFacts.forEach((fact, index) => {
                formData.append(`keyFactTitle`, fact.title);
                formData.append(`keyFactDescription`, fact.description);
            });
        }

        try {
            setBtnLoading(true)
            const url = id ? `${baseUrl.url}/api/product/${id}` : `${baseUrl.url}/api/product`;
            const method = id ? "PUT" : "POST";
            const res = await fetch(url, {
                method: method,
                headers: {
                    "Authorization": `Bearer ${accessToken}`
                },
                body: formData
            });

            if (res.status === 304) {
                callToast(toast, "warn", "No data changed");
                return;
            }

            if (res.ok) {
                callToast(toast, "success", `Product ${id ? "updated" : "created"} successfully`);
                navigate('/product')
            } else {
                const resData = await res.json();
                const {errors, message} = resData;
                console.log("resData", resData);
                callToast(toast, false, errors?.[0] || message || "Something went wrong");
            }
        } catch (error: any) {
            console.log("error", error.message);
            callToast(toast, false, "Network error occurred");
        } finally {
            setBtnLoading(false);
        }
    };


    const emptyTemplate = () => {
        return (
            <div className="h-[10px] w-[10px] m-1 border-round">
                <div className="flex flex-column w-full h-full justify-content-center align-items-center cursor-pointer"
                >
                    {formDataState.image_file ? (
                        <div className="p-fileupload-preview">
                            <img
                                alt="Default"
                                src={`${baseUrl?.url}/${formDataState.image_file}`}
                                height="140"
                            />
                        </div>
                    ) : (
                        <>
                            <i className="pi pi-image mt-3 p-5" style={{
                                fontSize: '5em',
                                borderRadius: '50%',
                                backgroundColor: 'var(--surface-b)',
                                color: 'var(--surface-d)'
                            }}></i>
                            <span style={{fontSize: '1.2em', color: 'var(--text-color-secondary)'}} className="my-5">
                                 Drag and Drop Image Here
                            </span>
                        </>
                    )}
                </div>
            </div>
        );
    };

    const onMetaTemplateSelect = (e: any) => {
        // setTotalSize_meta(totalSize_meta);
        setFormDataState(prev => ({
            ...prev,
            image_file: e.files[0],
        }));
    };

    const headerTemplate = (options: FileUploadHeaderTemplateOptions) => {
        const {className, chooseButton, cancelButton} = options;
        return (
            <div className={className}>
                <div className={'flex align-items-center gap-4'}>
                    {chooseButton}

                    {cancelButton}
                </div>
            </div>
        );
    };

    return (
        <div className="card">
            <PageHeading title={`${id ? "Update" : "Create"}  Product`} back/>
            <Toast ref={toast}/>
            <ConfirmDialog/>

            <form onSubmit={handleSubmit}>
                <div className="grid p-fluid">
                    <div className={'col-12'}>
                        <div className="grid">
                            <div className=" col-12 md:col-4 xl:col-3">
                                <Label label={'Product Category'} required={true}/>
                                <Dropdown
                                    id="productCategoryId"
                                    value={selectedProductCategory}
                                    options={productCategory}
                                    // onChange={(e: DropdownChangeEvent) => handleInputChange(e, 'productCategoryId')}
                                    // onChange={(e: DropdownChangeEvent) => handleChangeData('productCategoryId', e.target.value, formDataState, setFormDataState)}
                                    onChange={(e: DropdownChangeEvent) => setSelectedProductCategory(e.target.value)}
                                    placeholder="Select Category"
                                    optionLabel='name'
                                    className="w-full"
                                    showClear
                                />
                            </div>
                            <div className=" col-12 md:col-4 xl:col-3">
                                <Label label={'Pregnancy Level'} required={true}/>
                                <Dropdown
                                    id="pregnancyLevel"
                                    value={selectedPregnancyLevel}
                                    options={pregnancyLevel}
                                    // onChange={(e: DropdownChangeEvent) => handleChangeData('pregnancyLevel', e.target.value, formDataState, setFormDataState)}
                                    onChange={(e: DropdownChangeEvent) => setSelectedPregnancyLevel(e.target.value)}
                                    placeholder="Select Level"
                                    optionLabel='name'
                                    className="w-full"
                                    showClear
                                />
                            </div>
                            <div className=" col-12 md:col-4 xl:col-3">
                                <Label label={'Dosage Form'} required={true}/>
                                <Dropdown
                                    id="productDosageFormId"
                                    value={selectedProductDosage}
                                    options={dosageForm}
                                    // onChange={(e: DropdownChangeEvent) => handleChangeData('productDosageFormId', e.target.value, formDataState, setFormDataState)}
                                    onChange={(e: DropdownChangeEvent) => setSelectedProductDosage(e.target.value)}
                                    placeholder="Select Dosage Form"
                                    optionLabel='name'
                                    className="w-full"
                                    showClear
                                />
                            </div>

                        </div>
                    </div>
                    <div className=" col-12 md:col-4 xl:col-3">
                        <Label label={'Brand Name'} required={true}/>
                        <InputText
                            id="brandName"
                            value={formDataState.brandName}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeData('brandName', e.target.value, formDataState, setFormDataState)}
                            placeholder="Enter brand name"
                        />
                    </div>
                    <div className=" col-12 md:col-4 xl:col-3">
                        <Label label={'Generic Name'} required={true}/>
                        <InputText
                            id="genericName"
                            value={formDataState.genericName}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeData('genericName', e.target.value, formDataState, setFormDataState)}
                            placeholder="Enter generic name"
                        />
                    </div>
                    <div className=" col-12 md:col-4 xl:col-2">
                        <Label label={'Product Code'} required={true}/>
                        <InputText
                            id="productCode"
                            value={formDataState.productCode}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleChangeData('productCode', e.target.value, formDataState, setFormDataState)}
                            placeholder="Enter product code"
                        />
                    </div>
                    <div className="field col-12 md:col-4 xl:col-2">
                        <Label label={'Strength'} required={true}/>
                        <InputText
                            id="strength"
                            value={formDataState.strength}
                            onChange={(e) => handleChangeData('strength', e.target.value, formDataState, setFormDataState)}
                            placeholder="Enter strength"
                            className="w-full"
                        />
                    </div>
                </div>

                {/* Pricing Section */}
                <div className="grid p-fluid">
                    <div className="field col-12 md:col-3 xl:col-2">
                        <Label label={'MRP'} required={true}/>
                        <InputNumber
                            id="mrp"
                            value={formDataState.mrp}
                            onValueChange={(e: InputNumberValueChangeEvent) => handleChangeData('mrp', e.value, formDataState, setFormDataState)}
                            mode="currency"
                            currency="BDT"
                            // locale="bn-BD"
                            placeholder="Enter MRP"
                            className="w-full"
                        />
                    </div>

                    <div className="field col-12 md:col-3 xl:col-2">
                        <Label label={'Trade Price (with VAT)'} required={true}/>
                        <InputNumber
                            id="tradePriceVat"
                            value={formDataState.tradePriceVat}
                            onValueChange={(e: InputNumberValueChangeEvent) => handleChangeData('tradePriceVat', e.value, formDataState, setFormDataState)}
                            mode="currency"
                            currency="BDT"
                            // locale="bn-BD"
                            placeholder="Enter trade price"
                            className="w-full"
                        />
                    </div>

                    <div className="field col-12 md:col-3 xl:col-2">
                        <Label label={'Offer Price'} required={true}/>
                        <InputNumber
                            id="offerPrice"
                            value={formDataState.offerPrice}
                            onValueChange={(e: InputNumberValueChangeEvent) => handleChangeData('offerPrice', e.value, formDataState, setFormDataState)}
                            mode="currency"
                            currency="BDT"
                            // locale="bn-BD"
                            placeholder="Enter offer price"
                            className="w-full"
                        />
                    </div>

                    <div className="field col-12 md:col-3 xl:col-2">
                        <Label label={'Discount Price'} required={true}/>
                        <InputNumber
                            id="discountPrice"
                            value={formDataState.discountPrice}
                            onValueChange={(e: InputNumberValueChangeEvent) => handleChangeData('discountPrice', e.value, formDataState, setFormDataState)}
                            mode="currency"
                            currency="BDT"
                            // locale="bn-BD"
                            placeholder="Enter discount price"
                            className="w-full"
                        />
                    </div>

                    <div className="field col-12 lg:col-7 xl:col-5">
                        <Label label={'Description'} required={true}/>
                        <InputTextarea
                            id="description"
                            value={formDataState.description}
                            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => handleChangeData('description', e.target.value, formDataState, setFormDataState)}
                            rows={4}
                            placeholder="Enter product description"
                            className="w-full"
                        />
                    </div>
                </div>


                {/* Product Details Section */}
                <div className="grid p-fluid mt-1">
                    <div className=" col-12 lg:col-6 xl:col-5">
                        <Label label={'Composition'} required={true}/>
                        <Editor value={composition}
                                onTextChange={(e: any) => setComposition(e.htmlValue)}
                                style={{height: '320px'}}
                        />
                    </div>

                    <div className=" col-12 lg:col-6 xl:col-5">
                        <Label label={'Indication'} required={true}/>
                        <Editor value={indication}
                                onTextChange={(e: any) => setIndication(e.htmlValue)}
                                style={{height: '320px'}}/>
                    </div>


                    <div className="col-12">
                        <div className="grid">
                            <div className=" col-12 lg:col-7 xl:col-5">
                                <Label label={'Dosage'} required={true}/>
                                <Editor value={dosage}
                                        onTextChange={(e: any) => setDosage(e.htmlValue)}
                                        style={{height: '320px'}}/>
                            </div>

                            <div className="field col-12 md:col-6">
                                <Label label={'Pack Size'} required={true}/>
                                <Editor value={packSize}
                                        onTextChange={(e: any) => setPackSize(e.htmlValue)}
                                        style={{height: '320px'}}/>
                            </div>
                        </div>
                    </div>


                </div>


                <div className="grid mt-1 ">
                    <div className="col-12 xl:col-6 border border-1 border-round border-gray-300 p-3 ml-2 ">
                        <div className={"flex gap-3 align-items-center mb-3"}>
                            <div className={"text-600 text-base font-semibold"}>Key Facts</div>
                            <Button type={"button"} icon="pi pi-plus" outlined size={"small"}
                                    className={"w-2rem h-2rem"}
                                    onClick={handlePlus}/>
                        </div>
                        {
                            keyFacts?.map((fact, index: number) => {
                                const {id} = fact;

                                return <div key={index}
                                            className={`my-2 border-1 border-300 py-4 px-3 border-round-md relative `}>
                                    {keyFacts?.length > 1 &&
                                        <Button type={"button"}
                                                onClick={() => handleRemoveRow(id, keyFacts, setKeyFacts)}
                                                icon="pi pi-times" rounded text severity="danger"
                                                aria-label="Cancel"
                                                className={"absolute right-0"} style={{top: "-3px"}}
                                                size={"small"}/>}

                                    <div className="grid">
                                        <div className='col-12 md:col-6'>
                                            <label htmlFor={`keyFactTitle-${index}`}>Title</label>
                                            <InputText
                                                id={`keyFactTitle-${index}`}
                                                value={fact.title}
                                                onChange={(e) => {
                                                    handleDataUpdate(id, e.target.value, keyFacts, setKeyFacts, "title")
                                                }}
                                                placeholder={`Enter key fact ${index + 1} title`}
                                                className="w-full"
                                            />
                                        </div>

                                        <div className="col-12  md:col-6">
                                            <label htmlFor={`keyFactDescription-${index}`}>Description</label>
                                            <InputText
                                                id={`keyFactDescription-${index}`}
                                                value={fact.description}
                                                onChange={(e) => {
                                                    handleDataUpdate(id, e.target.value, keyFacts, setKeyFacts, "description")
                                                }}
                                                placeholder={`Enter key fact ${index + 1} description`}
                                                className="w-full"
                                            />
                                        </div>
                                    </div>
                                </div>
                            })
                        }
                    </div>
                </div>

                {/* Image Upload Section */}
                <div className="grid mt-3">
                    <div className="field col-12 md:col-6 xl:col-4">
                        <FileUpload
                            name="image_file"
                            accept="image/*"
                            maxFileSize={1000000}
                            // onUpload={onUpload}
                            chooseLabel="Select Image"
                            onSelect={onMetaTemplateSelect}
                            // cancelLabel="Cancel"
                            // uploadLabel="Upload"
                            customUpload
                            className="w-full"
                            headerTemplate={headerTemplate}
                            emptyTemplate={emptyTemplate}
                        />
                        {/*{formDataState.image_file && (*/}
                        {/*    <div className="mt-2">*/}
                        {/*        <small className="text-green-600">*/}
                        {/*            Selected: {formDataState.image_file.name}*/}
                        {/*        </small>*/}
                        {/*    </div>*/}
                        {/*)}*/}
                    </div>
                </div>

                {/* Submit Buttons */}
                <div>
                    <Button
                        type="submit"
                        label={`${id ? "Update" : "Create"}`}
                        loading={btnLoading}
                        className="p-button-primary"
                        // disabled={!isFormValid()}
                    />
                </div>
            </form>
        </div>
    );
};

export default CommonProduct;